import { translate } from 'App/Internationalization';
import FormField from 'shared/Forms/Fields/FormField';
import InputPostalCode from 'shared/Forms/Inputs/Address/InputPostalCode';
import React from 'react';

export default class FieldPostalCode extends React.Component {
	render() {
		const label = translate(
			'global.forms.inputs.address.postal_code.label'
		);

		return (
			<FormField
				className={this.props.className}
				help={translate('global.forms.help.zip_code')}
				inputName={this.props.name}
				label={this.props.label ?? label}
				labelClass={this.props.labelClass}
				name={this.props.name}
				required={this.props.required}
			>
				<InputPostalCode
					className={this.props.inputClass}
					disabled={this.props.disabled}
					name={this.props.name}
					required={this.props.required}
				/>
			</FormField>
		);
	}
}

FieldPostalCode.defaultProps = {
	className: InputPostalCode.defaultProps.className,
	disabled: InputPostalCode.defaultProps.disabled,
	inputClass: InputPostalCode.defaultProps.className,
	labelClass: FormField.defaultProps.labelClass,
	name: InputPostalCode.defaultProps.name,
	required: InputPostalCode.defaultProps.required,
};
